(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.afamily__form');
    const variants = [...root.querySelectorAll('[data-af-variant]')];
    const units = [...root.querySelectorAll('[data-af-unit]')];
    const thumbs = [...root.querySelectorAll('[data-af-image]')];
    const hero = root.querySelector('.afamily__hero');
    const submit = form.querySelector('[type="submit"]');
    const shipping = root.querySelector('[data-af-shipping]');
    const upsell = root.querySelector('[data-af-upsell]');
    function showImage(button) {
      if (!button || !hero) return;
      hero.src = button.dataset.afImage;
      hero.srcset = button.dataset.afSrcset;
      hero.alt = button.dataset.afAlt;
      thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === button)));
    }
    function sync(changeImage = false) {
      const selected = variants.find(v => v.checked) || variants[0];
      const count = Number(selected.dataset.count);
      units.forEach(unit => {
        const active = Number(unit.dataset.afUnit) <= count;
        unit.hidden = !active;
        unit.disabled = !active;
        const reuse = unit.querySelector('[data-af-reuse]');
        const same = Boolean(reuse && reuse.checked);
        const front = unit.querySelector('[data-af-front]');
        unit.querySelector('[data-af-front-wrap]').hidden = same;
        front.disabled = !active || same;
        front.required = active && !same;
        const marker = unit.querySelector('[data-af-reuse-property]');
        if (marker) marker.disabled = !active || !same;
        const back = unit.querySelector('[data-af-back]');
        const kind = back.selectedOptions[0]?.dataset.kind || '';
        const text = unit.querySelector('[data-af-text]');
        const photo = unit.querySelector('[data-af-back-photo]');
        unit.querySelector('[data-af-text-wrap]').hidden = kind !== 'text';
        unit.querySelector('[data-af-back-photo-wrap]').hidden = kind !== 'photo';
        text.disabled = !active || kind !== 'text';
        text.required = active && kind === 'text';
        photo.disabled = !active || kind !== 'photo';
        photo.required = active && kind === 'photo';
      });
      root.querySelectorAll('[data-af-total]').forEach(total => { total.textContent = selected.dataset.priceLabel; });
      shipping.textContent = count === 4 ? shipping.dataset.free : shipping.dataset.paid;
      shipping.classList.toggle('afamily__delivery', count === 4);
      upsell.textContent = count === 2 ? upsell.dataset.three : count === 3 ? upsell.dataset.four : upsell.dataset.free;
      if (changeImage) showImage(thumbs[count === 2 ? 1 : count === 3 ? 2 : 0]);
    }
    thumbs.forEach(button => button.addEventListener('click', () => showImage(button)));
    form.addEventListener('change', event => {
      const input = event.target;
      if (input.type === 'file') {
        input.setCustomValidity('');
        const file = input.files[0];
        const preview = input.parentElement.querySelector('[data-af-preview]');
        if (preview?.dataset.objectUrl) {
          URL.revokeObjectURL(preview.dataset.objectUrl);
          delete preview.dataset.objectUrl;
        }
        if (preview) preview.hidden = true;
        if (file) {
          if (file.size > 20 * 1024 * 1024) input.setCustomValidity(root.dataset.sizeError);
          else if (!/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) input.setCustomValidity(root.dataset.typeError);
          else if (preview && !/\.hei[cf]$/i.test(file.name)) {
            const url = URL.createObjectURL(file);
            preview.src = url;
            preview.dataset.objectUrl = url;
            preview.hidden = false;
          }
          if (!input.validity.valid) input.reportValidity();
        }
      }
      sync(input.matches('[data-af-variant]'));
      if (input.matches('[data-af-variant]')) {
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState(null, '', url);
      }
    });
    form.addEventListener('submit', event => {
      sync();
      if (!form.reportValidity() || form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.submitting = 'true';
      submit.textContent = root.dataset.addingLabel;
      submit.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => {
      delete form.dataset.submitting;
      submit.textContent = root.dataset.addLabel;
      submit.removeAttribute('aria-busy');
    });
    sync();
  }
  const boot = () => document.querySelectorAll('[data-afamily]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
